import { render, staticRenderFns } from "./BuyAgainMessage.vue?vue&type=template&id=22a7ac99&scoped=true"
import script from "./BuyAgainMessage.vue?vue&type=script&lang=ts"
export * from "./BuyAgainMessage.vue?vue&type=script&lang=ts"
import style0 from "./BuyAgainMessage.vue?vue&type=style&index=0&id=22a7ac99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7ac99",
  null
  
)

export default component.exports